import React, { useEffect, useState } from "react";
import "./Navbar.scss";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { clearCustomerAddressData } from '../../redux/customerAddressSlice';
import { logout } from '../../redux/agentSlice';
import { logoutUser } from '../../redux/userSlice';
import { clearCart } from '../../redux/atcSlice';
import { fetchCategories } from "../../services/category";
import { Autocomplete } from "../autocomplete/Autocomplete";
import imge from "../../assets/images/Ellipse 8.png"
import { toggleMenu, menuClose } from '../../redux/menuSlice';
import { setSelectedAddress, clearSelectedAddress, setCheckboxChecked } from '../../redux/selectedAddressSlice';
import { ChevronLeft } from "lucide-react";
import { useLocation } from "react-router-dom";


const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
console.log(location.pathname, "location.pathname");

  const [isClicked, setIsClicked] = useState(false);
  const dispatch = useDispatch();
  let data = localStorage.getItem("agentData")
  let parsedData = JSON.parse(data)

  console.log(parsedData?.agentEmail?.slice(0, 2), "parsedData");

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('agentData');
    localStorage.removeItem('isSelectedAddress');
    localStorage.removeItem('CustomerAddressData');
    localStorage.removeItem('grandTotal');
    localStorage.removeItem('CustomerAddressData');
    localStorage.removeItem('selectedAddress');
    localStorage.removeItem('isSelectedAddress');
    localStorage.removeItem('updateProfile');
    localStorage.removeItem('user_token');
    dispatch(clearCustomerAddressData());
    dispatch(menuClose());
    dispatch(logout());
    dispatch(logoutUser());
    dispatch(clearCart());
    dispatch(setSelectedAddress(null));
    dispatch(clearSelectedAddress());
    dispatch(setCheckboxChecked(true));
    navigate('/');
  };

  const togglePopup = () => {
    setIsClicked(!isClicked);
  };
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();
        console.log("Fetched categories:", data);
        setCategories(data?.report_categories)
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    loadCategories();
  }, []);

  console.log(categories,"categories");
  
  const handleSelect = (value) => {
    console.log('Selected:', value);
  };
  const handleClose = () => {
    togglePopup();
    handleLogout();
  };
  return (
    <header className="headers">
      <div className="left-section">
        <button className="toggle-button" onClick={toggleSidebar}>☰</button>
        <div>
          <ChevronLeft
        style={{cursor: "pointer"}}
        onClick={()=>{
          // navigate(-1)  
          if (location.pathname === "/dashboard/reports") {
            navigate("/dashboard/category/list")
          } else if (location.pathname === "/dashboard") {
            navigate("/categories")
          }else if (location.pathname === "/dashboard/category/list") {
            navigate("/dashboard")
          }
        //   else if (location.pathname === "/dashboard/salesorderadvanced") {
        //     navigate("/dashboard")
        // }
      }}
          />
        </div>
        <div className="welcome-text">Welcome, Admin</div>
      </div>
      <div className="right-section">
        {/* <div>
          <Autocomplete suggestions={categories} onSelect={handleSelect} />
        </div> */}
        {/* <div className="search-box">
        <input type="text" placeholder="Search..." />
        <i className="icon-search" />
      </div> */}

        {/* <div className="icon">⚙️</div> */}
        {/* <div className="profile-pic">
        <img src={imge} alt="Admin" />
      </div> */}
        <div className="profile-container">
          <div
            className="profile-pic"
            onClick={togglePopup}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: '#f26c0d',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '16px',
              textTransform: "uppercase",
              cursor: 'pointer',
            }}>{parsedData?.agentEmail?.slice(0, 2)}</div>
          </div>

          {isClicked && (
            <div className="overlay">
              <div className="popup-card">
                {/* <p style={{ paddingTop: "70px", fontWeight: "600px", fontSize: "16px" }}>Are Want to Sure Logout ?</p>
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingTop: "30px",
                  gap: "20px"
                }} >
                  <button onClick={handleClose}>Confirm</button>

                  <button onClick={() => {
                    setIsClicked(false);
                  }}>Cancel</button>
                </div> */}
                <div className="icon">
                  <span>⚠️</span>
                </div>
                <h2>Sign out</h2>
                <p>Are you sure you would like to sign out of your account?</p>
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px"
                }} >
                  <button onClick={handleClose}>Sign out                  </button>

                  <button onClick={() => {
                    setIsClicked(false);
                  }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
